export const DEFAULT_SEARCH_VALUE = 'The'
export const API_KEY = 'f54d0c87dc6afc7ca1a6b7d4cdc26242' 
export const FETCH_TIME_REDUCER = 500